import { render, staticRenderFns } from "./router.vue?vue&type=template&id=28104842&scoped=true&"
import script from "./router.vue?vue&type=script&lang=js&"
export * from "./router.vue?vue&type=script&lang=js&"
import style0 from "./router.vue?vue&type=style&index=0&id=28104842&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28104842",
  null
  
)

export default component.exports